/**
 * 提示语 Token 预估（纯前端启发式估算，非模型实际分词结果）
 *
 * - 中文等 CJK 字符：约 1 字符 = 1 token
 * - 其余字符（英文、符号、空白等）：约 4 字符 = 1 token
 */

// 超过该字符数时改用采样估算，避免超长内容长时间占用主线程
const SAMPLE_THRESHOLD = 200_000;
// 采样长度
const SAMPLE_SIZE = 20_000;

// 系统提示、指令模板等固定开销的粗略常数（单位：token）
// 纯前端无法得知后端实际系统提示词长度，此处为经验值，可按实际调整
export const INPUT_TOKEN_OVERHEAD = 200;

const isCjkCodePoint = (code: number) =>
    (code >= 0x2e80 && code <= 0x9fff) || // CJK 部首、符号、假名、汉字
    (code >= 0xac00 && code <= 0xd7af) || // 韩文
    (code >= 0xf900 && code <= 0xfaff) || // 兼容汉字
    (code >= 0xff00 && code <= 0xffef); // 全角字符

const countTokens = (text: string) => {
    let cjkCount = 0;
    let otherCount = 0;

    // for...of 按 code point 遍历，避免代理对被拆成两个字符
    for (const char of text) {
        if (isCjkCodePoint(char.codePointAt(0) as number)) {
            cjkCount += 1;
        } else {
            otherCount += 1;
        }
    }

    return cjkCount + Math.ceil(otherCount / 4);
};

export const estimateTokenCount = (text: string) => {
    if (!text) return 0;

    if (text.length > SAMPLE_THRESHOLD) {
        const sample = text.slice(0, SAMPLE_SIZE);
        return Math.round(countTokens(sample) * (text.length / SAMPLE_SIZE));
    }

    return countTokens(text);
};
